import BaseRepository, { IFilterSettings } from 'Domain/Repositories/BaseRepository/BaseRepository';
import { AppUser }                         from 'Domain/Models';

const config = {
    model: AppUser,
    baseRoute: '/admin/app-user',
    singular: 'appUser',
    plural: 'appUsers',
}

class AppUserRepository extends BaseRepository<AppUser, typeof config.singular, typeof config.plural> {

  findAll(filterSettings: IFilterSettings = { filter: [] }) {
    if(!filterSettings?.sorting) {
      filterSettings.sorting = {
        field: 'username',
        order: 'ASC',
      }
    }
    return this.setFilterSettings(filterSettings).makeRequest({
      path: this.overrideRoutes['findAll'] || this.baseRoute,
      data: this.getFilterSettings(),
      type: 'GET',
      callback: this.initializeModels
    });
  }

  removeAppUserFromOrganisation({ appUserId, organisationId }: { appUserId: string, organisationId: string }) {
    return this.makeRequest({
      path: `${this.baseRoute}/remove-from-organisation`,
      data: { appUserId, organisationId },
      type: 'POST',
      callback: () => undefined
    });
  }

  findEvents({ userId, organisationId }: { userId: string, organisationId: string }) {
    return this.makeRequest({
      path: `${this.baseRoute}/${userId}/event`,
      data: { organisationId },
      type: 'GET',
      callback: ({ eventIds = [] }: { eventIds: string[] }) => ({ eventIds })
    });
  }

  updateEvents({ userId, organisationId, eventIds }: { userId: string, organisationId: string, eventIds: string[] }) {
    return this.makeRequest({
      path: `${this.baseRoute}/${userId}/event`,
      data: { organisationId, eventIds },
      type: 'PATCH',
      callback: ({ eventIds: assignedEventIds = [] }: { eventIds: string[] }) => ({ eventIds: assignedEventIds })
    });
  }

  findOrganisations({ userId }: { userId: string }) {
    return this.makeRequest({
      path: `${this.baseRoute}/${userId}/organisation`,
      type: 'GET',
      callback: ({ organisations = [] }: { organisations: TAppUserOrganisation[] }) => ({ organisations })
    });
  }

  assignOrganisation({ userId, organisationId, userRole }: { userId: string, organisationId: string, userRole?: string }) {
    return this.makeRequest({
      path: `${this.baseRoute}/${userId}/organisation`,
      data: { organisationId, userRole },
      type: 'PATCH',
      callback: ({ organisations = [] }: { organisations: TAppUserOrganisation[] }) => ({ organisations })
    });
  }

}

export type TAppUserOrganisation = { organisationId: string, organisationName: string | null, userRole: string | null };

export default new AppUserRepository(config);
